module.exports = __webpack_public_path__ + "static/media/link.21070156.svg";